<template lang='pug'>
  digi-flex.home.section.centered.column( role='region' aria-labelledby="splash-logo" )
    router-link.logo( :to='{ name: "blog" }' ) 
      img( src='/logo.png' )
    
    router-link.logo( :to='{ name: "blog" }' ).slogan For The Digital Economy
</template>

<script>
  import Logo from '@/components/logo'

  export default {
    name: 'home',

    components: {
      Logo
    }
  }
</script>

<style scoped lang="stylus">
  @import url('https://fonts.googleapis.com/css?family=Yellowtail|Lato')

  .home
    transition all 1.28s
    text-align center
    max-width 100vw
    height 100vh
    background linear-gradient(
      135deg,
      rgb( 56 56 56 ),
      rgb( 72 72 72 ),
      rgb( 88 88 88 )
    )
    @media( max-width: 1600px )
      font-size .9em

    @media( max-width: 1080px )
      font-size .8em

    @media( max-width: 800px )
      font-size .7em

    @media( max-width: 480px )
      font-size .5em

  a
    text-decoration none
    color rgb( 192 192 192 )
    font-family Lato
    &:hover
      color white

  .logo
    position relative
    animation rotate-y 2100ms, slide-in-from-top 2100ms
    img
      width 24em
  
  .slogan
    font-size 3.1em
    text-shadow var(--text-shadow-rev)
    font-family Yellowtail //Arizonia //Courgette //Ubuntu
    animation fade-in 2100ms
    color rgb( 200 150 120 )
</style>
